/**
 * Filtre de l'API sur le mois des périodes (DateFilter) : toute l'année choisie, sur des dates sans heure (aucun fuseau
 * en jeu). Sans année, aucun filtre de date : les 12 dernières périodes clôturées (tri et itemsPerPage de la requête),
 * y compris celle du mois en cours, clôturée sans attendre la fin du mois.
 */
export function periodFilters(year: number | null): Record<string, string> {
  if (year === null) return {};
  return { 'month[after]': `${year}-01-01`, 'month[strictly_before]': `${year + 1}-01-01` };
}

/** Années par grille du year picker : 4 rangées de 3 */
export const YEARS_PER_GRID = 12;

/** Dernière année de la grille qui contient year, les grilles étant alignées pour que max soit la dernière case */
export function gridEndFor(year: number, max: number): number {
  return max - Math.floor((max - year) / YEARS_PER_GRID) * YEARS_PER_GRID;
}
